module.exports = __webpack_public_path__ + "static/img/hyyy_ct_b.3caddab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/hyyy_ct_b.png
// module id = WuVi
// module chunks = 1